<template>
  <div>
    <div class="wrap">
      <h2>查询</h2>
      <input type="text" name="ms" placeholder="请输入共享编号" v-model="queryVal" />
      <button @click="queryMS">查询</button>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
export default {
  data() {
    return {
      queryVal: "",
    };
  },
  methods: {
    queryMS() {
        let _this = this;
      _this.$router.push({path:'/',query:{ms:_this.queryVal}});
    },
  },
  components: {
    Footer,
  },
};
</script>

<style lang="less">
@import "../assets/less/Share.less";
</style>
